// extracted by mini-css-extract-plugin
module.exports = {"container":"NotAlignedModal_container__df3g2","headerContent":"NotAlignedModal_headerContent__1xeaJ","message":"NotAlignedModal_message__1A2jN"};